<template>
  <div class="games-container">
    <h1>Games</h1>
    <div class="games-grid">
      <div v-for="game in games" :key="game.id" class="game-tile">
        <img :src="game.image" :alt="game.name" />
        <button
          @click="playGame({ points: game.cost, coinType: game.coinType })"
          class="play-button"
        >
          Play Now
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import slotsImage from "@/assets/slots.png";
import blackjackImage from "@/assets/blackjack.png";
import rouletteImage from "@/assets/roulette.png";
import pokerImage from "@/assets/poker.png";
import bingobonanzaImage from "@/assets/bingobonanza.png";
import gemRushImage from "@/assets/gemrush.png";
import luckyCatSpinsImage from "@/assets/luckycatspins.png";
import witchsFortuneImage from "@/assets/witchsfortune.png";

export default {
  data() {
    return {
      games: [
        {
          id: 1,
          name: "Slots Paradise",
          image: slotsImage,
          cost: 10,
          coinType: "gold",
        },
        {
          id: 2,
          name: "Blackjack Pro",
          image: blackjackImage,
          cost: 90,
          coinType: "sweeps",
        },
        {
          id: 3,
          name: "Roulette Royal",
          image: rouletteImage,
          cost: 1020,
          coinType: "gold",
        },
        {
          id: 4,
          name: "Poker Party",
          image: pokerImage,
          cost: 5,
          coinType: "sweeps",
        },
        {
          id: 5,
          name: "Bingo Bonanza",
          image: bingobonanzaImage,
          cost: 10,
          coinType: "sweeps",
        },
        {
          id: 6,
          name: "Gem Rush",
          image: gemRushImage,
          cost: 230,
          coinType: "gold",
        },
        {
          id: 7,
          name: "Lucky Cat Spins",
          image: luckyCatSpinsImage,
          cost: 90,
          coinType: "gold",
        },
        {
          id: 7,
          name: "Witch's Fortune",
          image: witchsFortuneImage,
          cost: 300,
          coinType: "gold",
        },
      ],
    };
  },
  methods: {
    ...mapActions(["playGame"]),
  },
};
</script>

<style scoped>
.games-container {
  max-width: 1200px;
  margin: 0 auto;
}

.games-container h1 {
  color: var(--text-color);
}

.games-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 2rem;
  padding: 1rem;
}

.game-tile {
  background: var(--card-background);
  border-radius: 10px;
  padding: 1rem;
  text-align: center;
  transition: transform 0.3s ease, background 0.3s ease;
  border: 1px solid var(--accent-color);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.game-tile:hover {
  transform: translateY(-5px);
}

.game-tile img {
  width: 200px;
  height: 200px;
  object-fit: fit;
  border-radius: 8px;
}

.play-button {
  background-color: var(--secondary-color);
  color: white;
  border: none;
  padding: 0.8rem 1.5rem;
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.play-button:hover {
  background-color: var(--accent-color);
  color: var(--primary-color);
}

/* Mobile responsive styles */
@media (max-width: 768px) {
  .games-container {
    padding: 0 1rem;
  }

  .games-container h1 {
    font-size: 1.8rem;
    text-align: center;
    margin-bottom: 1.5rem;
    color: var(--text-color);
  }

  .games-grid {
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 1.5rem;
    padding: 0.5rem;
  }

  .game-tile {
    padding: 1rem 0.8rem;
    border-radius: 8px;
  }

  .game-tile img {
    width: 160px;
    height: 160px;
    margin-bottom: 0.8rem;
  }

  .play-button {
    padding: 0.7rem 1.2rem;
    font-size: 0.9rem;
    border-radius: 20px;
  }
}

@media (max-width: 480px) {
  .games-container {
    padding: 0 0.75rem;
  }

  .games-container h1 {
    font-size: 1.6rem;
    margin-bottom: 1.2rem;
  }

  .games-grid {
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: 1rem;
    padding: 0.25rem;
  }

  .game-tile {
    padding: 0.8rem 0.6rem;
    border-radius: 6px;
  }

  .game-tile img {
    width: 130px;
    height: 130px;
    margin-bottom: 0.6rem;
  }

  .play-button {
    padding: 0.6rem 1rem;
    font-size: 0.85rem;
    border-radius: 18px;
    width: 100%;
    max-width: 140px;
  }
}

/* Single column layout for very small screens */
@media (max-width: 360px) {
  .games-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
    padding: 0;
  }

  .game-tile {
    padding: 1rem;
    max-width: 280px;
    margin: 0 auto;
  }

  .game-tile img {
    width: 150px;
    height: 150px;
  }

  .play-button {
    width: 100%;
    max-width: 180px;
    padding: 0.8rem 1.2rem;
    font-size: 0.9rem;
  }
}

/* Landscape mobile orientation */
@media (max-width: 768px) and (orientation: landscape) {
  .games-container h1 {
    font-size: 1.5rem;
    margin-bottom: 1rem;
  }

  .games-grid {
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
    gap: 1rem;
    padding: 0.5rem;
  }

  .game-tile {
    padding: 0.8rem;
  }

  .game-tile img {
    width: 120px;
    height: 120px;
    margin-bottom: 0.5rem;
  }

  .play-button {
    padding: 0.5rem 1rem;
    font-size: 0.8rem;
  }
}

/* Very large mobile screens */
@media (max-width: 768px) and (min-width: 600px) {
  .games-grid {
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    gap: 1.8rem;
  }

  .game-tile img {
    width: 180px;
    height: 180px;
  }

  .play-button {
    padding: 0.8rem 1.4rem;
    font-size: 0.95rem;
  }
}
</style>
